module.exports = __webpack_public_path__ + "static/media/reboot.c6fed8af.svg";